import React from 'react'
import { connect } from 'react-redux'
import prefetch from 'prefetch-image'
import { t } from 'i18next'

import Card from '../components/Card'
import Cards from '../components/Cards'
import Images from '../components/Images'
import Icons from '../components/Icons'
import { SHOW_PAGE } from '../actions'
import { padding } from '../utils'
import Header from '../components/header'

const Image = ({ image }) => {
  const style = {
    backgroundImage: `url(${image})`
  }

  return <div className="background" style={style} />
}

const Holder = ({ trivia, updatePage }) => {
  const { questions, current } = trivia

  if (current < questions.length - 1) {
    const width = window.outerWidth
    const display = width < 680 ? 'mobile' : 'desktop'
    const image = `/images/${display}/Imagen_${padding(current + 1)}.jpg`
    prefetch([image])
  }

  return (
    <div className="view-inner">
      <Header css="card-header">
        <h3>
          {t('trivia.question', {
            current: current + 1,
            total: questions.length
          })}
        </h3>
      </Header>
      <Images current={current}>
        {questions.map((question, index) => {
          const width = window.outerWidth
          const display = width < 680 ? 'mobile' : 'desktop'
          const image = `/images/${display}/Imagen_${padding(index + 1)}.jpg`
          return <Image key={question.Question} image={image} />
        })}
      </Images>

      <Icons />

      <Cards current={current}>
        {questions.map((question, index) => {
          return <Card key={question.Question} question={question} last={index === questions.length - 1} />
        })}
      </Cards>
    </div>
  )
}

const mapState = state => {
  const { trivia } = state
  return {
    trivia
  }
}

const mapDispatch = dispatch => {
  return {
    updatePage: page => {
      dispatch({
        type: SHOW_PAGE,
        payload: page
      })
    }
  }
}

const Trivia = connect(mapState, mapDispatch)(Holder)
Trivia.displayName = 'trivia'

export default Trivia



// WEBPACK FOOTER //
// ./src/pages/Trivia.js